/* FAYQ — page produit v3 (maquette FAYQ-produit-v3) branchée sur les variantes Shopify. */
(function () {
  var $ = function (id) { return document.getElementById(id); };
  var q = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfgEl = $('pv3Config');
  if (!cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var tastes = {};
  try { tastes = JSON.parse(($('pv3Tastes') || {}).textContent || '{}'); } catch (e) {}

  var G = window.FAYQ || {}, I = G.i18n || {}, EN = G.locale === 'en';
  var tr = function (k, v) { var s = I[k] || k; for (var x in (v || {})) s = s.split('{' + x + '}').join(v[x]); return s; };
  /* Prix : 1 232,46 DH (fr) · 1,232.46 MAD (en) */
  function fm(cents) {
    var c = Math.round(cents), u = Math.floor(c / 100), d = c % 100;
    return String(u).replace(/\B(?=(\d{3})+(?!\d))/g, EN ? ',' : ' ') + (EN ? '.' : ',') + (d < 10 ? '0' : '') + d + (EN ? ' MAD' : ' DH');
  }

  /* ---------- Données ---------- */
  var F = {}, KEYS = [];
  cfg.variants.forEach(function (v) {
    F[v.key] = { id: v.id, name: v.name, color: v.color, available: v.available, price: v.price, compare: v.compare, image: v.image, taste: tastes[v.key] || '' };
    KEYS.push(v.key);
  });
  var ref = F[cfg.current] || F[KEYS[0]];
  var OFFERS = cfg.tiers.map(function (t) {
    var price = Math.round(ref.price * t.n * (100 - t.pct) / 100);
    var was = ref.compare > ref.price ? ref.compare * t.n : (t.pct ? ref.price * t.n : 0);
    return { id: String(t.n), n: t.n, pct: t.pct, price: price, was: was > price ? was : 0 };
  });
  var s = { f: cfg.current, o: String(cfg.defaultQty || OFFERS[0].n), mix: {} };
  if (!OFFERS.some(function (o) { return o.id === s.o; })) s.o = OFFERS[0].id;
  KEYS.forEach(function (k) { s.mix[k] = 0; });

  var offer = function () { return OFFERS.filter(function (o) { return o.id === s.o; })[0]; };
  var ship = function () { return offer().n >= cfg.freeQty ? 0 : cfg.shipping; };
  var total = function () { return offer().price + ship(); };
  var sum = function () { return KEYS.reduce(function (a, k) { return a + s.mix[k]; }, 0); };
  var used = function () { return KEYS.filter(function (k) { return s.mix[k] > 0; }); };
  var mixed = function () { return used().length > 1; };
  var single = function () { var u = used(); return u.length === 1 ? u[0] : s.f; };
  function setAll(k) { KEYS.forEach(function (x) { s.mix[x] = 0; }); s.mix[k] = offer().n; s.f = k; }
  function fitMix() {
    var n = offer().n;
    if (!mixed() || n === 1) { setAll(n === 1 && F[s.f] ? s.f : single()); return; }
    while (sum() > n) { var big = KEYS.slice().sort(function (a, b) { return s.mix[b] - s.mix[a]; })[0]; s.mix[big]--; }
    while (sum() < n) s.mix[s.f]++;
  }
  var boxes = function (n) { return n + ' ' + tr(n > 1 ? 'boxes' : 'box'); };
  var label = function () {
    var o = offer();
    if (!mixed()) return boxes(o.n) + ' ' + F[single()].name;
    return boxes(o.n) + (EN ? ': ' : ' : ') + used().map(function (k) { return s.mix[k] + ' ' + F[k].name; }).join(' + ');
  };
  setAll(s.f);

  /* Lien « Packs » : ?offre=3 présélectionne l'offre et un mélange 1 de chaque saveur */
  var fromPack = false;
  try {
    var po = new URLSearchParams(location.search).get('offre');
    if (po && OFFERS.some(function (o) { return o.id === po; })) {
      s.o = po; fromPack = true;
      var avail = KEYS.filter(function (k) { return F[k].available; });
      var n0 = offer().n;
      KEYS.forEach(function (k) { s.mix[k] = 0; });
      if (n0 >= avail.length && avail.length > 1) { for (var pi = 0; pi < n0; pi++) s.mix[avail[pi % avail.length]]++; }
      else setAll(s.f);
    }
  } catch (e) {}

  /* ---------- Rendu ---------- */
  function setText(id, t) { var el = $(id); if (el) el.textContent = t; }
  function render(changedFlavor) {
    var o = offer(), mx = mixed(), f = F[single()];
    document.documentElement.style.setProperty('--c', mx ? 'var(--fajr)' : f.color);
    var stage = $('stage');
    if (stage) stage.style.background = mx ? 'linear-gradient(135deg,' + used().map(function (k) { return F[k].color; }).join(',') + ')' : '';
    var name = mx ? tr('mix') : f.name;
    var h = $('h1name');
    if (h && h.textContent !== name) { h.textContent = name; h.classList.remove('swap'); void h.offsetWidth; h.classList.add('swap'); }
    setText('word', name.toUpperCase());
    setText('crumb', cfg.productName + ' ' + name);
    setText('flavorLabel', mx ? 'mélange' : f.name);
    setText('taste', mx ? tr('your_mix') + ' ' + used().map(function (k) { return s.mix[k] + ' ' + F[k].name; }).join(', ') + '.' : f.taste);
    q('.fbtn').forEach(function (b) { b.setAttribute('aria-pressed', !mx && b.dataset.f === single() ? 'true' : 'false'); });
    q('.tc').forEach(function (b) { b.setAttribute('aria-pressed', !mx && b.dataset.f === single() ? 'true' : 'false'); });
    q('.offer').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.o === s.o ? 'true' : 'false'); });
    renderMixer();

    setText('price', fm(o.price));
    var was = $('was'); if (was) { was.hidden = !o.was; was.textContent = o.was ? fm(o.was) : ''; }
    var save = $('save'); if (save) { save.hidden = !o.was; save.textContent = o.was ? '−' + fm(o.was - o.price) : ''; }
    setText('per', tr('per_pouch', { p: fm(o.price / (20 * o.n)) }));

    var sh = ship(), miss = cfg.freeQty - o.n;
    var st = $('shipText');
    if (st) st.innerHTML = sh ? tr('ship_paid', { fee: fm(sh), n: boxes(cfg.freeQty), pct: (OFFERS.filter(function (x) { return x.n >= cfg.freeQty; })[0] || { pct: 0 }).pct }) : tr('ship_free');
    var m = $('meter'); if (m) m.style.width = Math.min(100, o.n / cfg.freeQty * 100) + '%';

    setText('rProd', label());
    setText('rShip', sh ? fm(sh) : tr('free'));
    var t = $('rTot'); if (t) { t.textContent = fm(total()); t.classList.remove('bump'); void t.offsetWidth; t.classList.add('bump'); }
    setText('bbName', label());
    setText('bbBtn', tr('order_total', { t: fm(total()) }));
    var fb = $('finalBtn'); if (fb && fb.firstChild) fb.firstChild.nodeValue = tr('order_now_total', { t: fm(total()) });

    // Photo de la saveur (ou des trois saveurs pour un mélange)
    var img = mx ? cfg.mixImage : f.image;
    if (img) showPhoto(img, mx ? tr('trio_alt') : tr('tin_alt', { f: f.name }));
    if (changedFlavor) setView(0);
  }

  function renderMixer() {
    var mxEl = $('mixer'); if (!mxEl) return;
    var n = offer().n, t = sum();
    mxEl.hidden = n < 2 || KEYS.length < 2;
    if (mxEl.hidden) return;
    var cnt = $('mixCnt'); cnt.textContent = t + '/' + boxes(n); cnt.classList.toggle('full', t === n);
    var list = []; KEYS.forEach(function (k) { for (var i = 0; i < s.mix[k]; i++) list.push(F[k].color); });
    var bx = ''; for (var i = 0; i < n; i++) bx += '<i' + (list[i] ? ' style="background:' + list[i] + '"' : '') + '></i>';
    $('mixBoxes').innerHTML = bx;
    $('mixRows').innerHTML = KEYS.map(function (k) {
      var dis = !F[k].available;
      return '<div class="mrow"><span class="sw" style="background:' + F[k].color + '"></span><b>' + F[k].name + '</b><div class="stepper"><button type="button" data-m="' + k + '" data-d="-1" aria-label="' + tr('one_less', { f: F[k].name }) + '"' + (s.mix[k] ? '' : ' disabled') + '>−</button><output>' + s.mix[k] + '</output><button type="button" data-m="' + k + '" data-d="1" aria-label="' + tr('one_more', { f: F[k].name }) + '"' + (dis ? ' disabled' : '') + '>+</button></div></div>';
    }).join('');
    $('presets').innerHTML = (n >= KEYS.length ? '<button type="button" class="chip" data-p="each">' + tr('one_each') + '</button>' : '') +
      KEYS.filter(function (k) { return F[k].available; }).map(function (k) { return '<button type="button" class="chip" data-p="' + k + '">' + tr('all_of', { f: F[k].name }) + '</button>'; }).join('');
    var miss = n - t, msg = $('mixMsg');
    msg.hidden = !miss; msg.textContent = miss ? tr('missing', { n: boxes(miss) }) : '';
  }

  var mixer = $('mixer');
  if (mixer) mixer.addEventListener('click', function (e) {
    var b = e.target.closest('[data-m],[data-p]'); if (!b) return;
    var n = offer().n;
    if (b.dataset.p) {
      if (b.dataset.p === 'each') {
        var av = KEYS.filter(function (k) { return F[k].available; });
        KEYS.forEach(function (k) { s.mix[k] = 0; });
        for (var i = 0; i < n; i++) s.mix[av[i % av.length]]++;
      } else setAll(b.dataset.p);
    } else {
      var k = b.dataset.m, d = +b.dataset.d;
      if (d < 0) { if (s.mix[k]) s.mix[k]--; }
      else if (sum() < n) s.mix[k]++;
      else {
        var from = KEYS.filter(function (x) { return x !== k && s.mix[x] > 0; }).sort(function (a, c) { return s.mix[c] - s.mix[a]; })[0];
        if (from) { s.mix[from]--; s.mix[k]++; }
      }
      s.f = k;
    }
    render(false);
  });

  /* ---------- Pour qui ? : onglets + bouton « Choisir » ---------- */
  var whoTabs = q('.pv3 .who-tab');
  function whoSelect(tab, focus) {
    whoTabs.forEach(function (t) {
      var on = t === tab, panel = $(t.getAttribute('aria-controls'));
      t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
      if (panel) panel.hidden = !on;
    });
    if (focus) tab.focus();
    tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
  }
  whoTabs.forEach(function (t, i) {
    t.addEventListener('click', function () { whoSelect(t, false); });
    t.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
      e.preventDefault(); whoSelect(whoTabs[(i + d + whoTabs.length) % whoTabs.length], true);
    });
  });
  document.addEventListener('click', function (e) {
    var p = e.target.closest('[data-pick]'); if (!p) return;
    var k = p.getAttribute('data-pick');
    if (!F[k] || !F[k].available) return;
    setAll(k); render(true);
    try { var u = new URL(location.href); u.searchParams.set('variant', F[k].id); history.replaceState(null, '', u.toString()); } catch (err) {}
    var top = document.querySelector('.pv3 .top'); if (top) top.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.fbtn[data-f],.tc[data-f],.offer[data-o]'); if (!b) return;
    if (b.dataset.o) { s.o = b.dataset.o; fitMix(); render(false); return; }
    if (!F[b.dataset.f] || !F[b.dataset.f].available) return;
    setAll(b.dataset.f); render(true);
    try { var u = new URL(location.href); u.searchParams.set('variant', F[s.f].id); history.replaceState(null, '', u.toString()); } catch (err) {}
    if (b.classList.contains('tc')) document.querySelector('.pv3 .top').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------- Vues + photos ---------- */
  function showPhoto(src, alt) {
    var p = $('pv3Photo'); if (!p || p.getAttribute('src') === src) return;
    p.removeAttribute('srcset'); p.src = src; if (alt) p.alt = alt;
    q('.pv3 .thumbs button').forEach(function (b) { b.setAttribute('aria-current', b.dataset.src === src ? 'true' : 'false'); });
  }
  function setView(i) {
    q('.pv3 .view').forEach(function (v, k) { v.classList.toggle('on', k === i); });
    q('.pv3 .tab').forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    if (i === 1) q('#openBox i').forEach(function (p) { p.style.animation = 'none'; void p.offsetWidth; p.style.animation = ''; });
  }
  q('.pv3 .tab').forEach(function (t) { t.addEventListener('click', function () { setView(+t.dataset.view); }); });
  q('.pv3 .thumbs button').forEach(function (b) {
    b.addEventListener('click', function () { setView(0); showPhoto(b.dataset.src, b.dataset.alt); });
  });

  /* ---------- 02 Minute par minute ---------- */
  var tl = $('tl');
  if (tl) {
    var steps = q('#steps .step');
    var TL = steps.map(function (b) { return { t: +b.dataset.t, title: b.dataset.title, text: b.dataset.text }; });
    var setTime = function (v) {
      v = +v; tl.value = v; setText('clock', v); tl.setAttribute('aria-valuetext', v + ' ' + tr(v > 1 ? 'minutes' : 'minute'));
      var cur = TL[0]; TL.forEach(function (x) { if (v >= x.t) cur = x; });
      if (cur) { setText('tlTitle', cur.title); setText('tlText', cur.text); }
      steps.forEach(function (b) { b.setAttribute('aria-pressed', cur && +b.dataset.t === cur.t ? 'true' : 'false'); });
      var p = $('mPouch'), g = $('glow'), lip = $('lip');
      p.style.top = v === 0 ? '18%' : v >= 28 ? '8%' : '34%';
      p.style.opacity = v >= 28 ? '.25' : '1';
      p.style.scale = v >= 5 ? (1 - Math.min(v, 25) / 120).toFixed(2) : '1';
      g.style.opacity = v < 5 ? 0 : Math.min(1, (v - 3) / 12).toFixed(2);
      g.style.scale = (0.7 + Math.min(v, 20) / 30).toFixed(2);
      lip.style.translate = '0 ' + (v === 0 || v >= 28 ? '10%' : '0');
    };
    tl.addEventListener('input', function () { setTime(this.value); });
    steps.forEach(function (b) { b.addEventListener('click', function () { setTime(b.dataset.t); }); });
    setTime(0);
  }

  /* ---------- 03 Calculateur ---------- */
  var calcEl = document.querySelector('[data-calc]');
  if (calcEl) {
    var PM = +calcEl.dataset.pouchMg || 100, MAX = +calcEl.dataset.maxMg || 400, MAXP = +calcEl.dataset.maxPouches || 4;
    var rows = q('#rows .row');
    var calc = function () {
      var usedMg = rows.reduce(function (a, r) { return a + (+r.querySelector('output').textContent) * (+r.dataset.mg); }, 0);
      var n = Math.max(0, Math.min(MAXP, Math.floor((MAX - usedMg) / PM)));
      var pm = n * PM, pctUsed = Math.min(100, usedMg / MAX * 100);
      $('gUsed').style.width = pctUsed + '%';
      $('gPouch').style.left = pctUsed + '%';
      $('gPouch').style.width = Math.min(100 - pctUsed, pm / MAX * 100) + '%';
      setText('usedMg', usedMg); setText('pouchMg', pm);
      var v = $('verdict');
      v.classList.toggle('alert', n === 0);
      v.textContent = n === 0 ? tr('none_today') : tr(n > 1 ? 'possible_many' : 'possible_one', { n: n });
      setText('advice', usedMg >= MAX ? tr('adv_over', { max: MAX })
        : n === 0 ? tr('adv_low', { left: MAX - usedMg, pm: PM })
        : tr('adv_ok', { left: MAX - usedMg }));
    };
    $('rows').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-d]'); if (!b) return;
      var out = b.parentNode.querySelector('output');
      out.textContent = Math.max(0, Math.min(10, (+out.textContent) + (+b.dataset.d)));
      calc();
    });
    calc();
  }

  /* ---------- 04 Ingrédients ---------- */
  q('.pv3 .ing button').forEach(function (b) {
    b.addEventListener('click', function () { var c = b.parentNode, o = c.dataset.open === 'true'; c.dataset.open = o ? 'false' : 'true'; b.setAttribute('aria-expanded', o ? 'false' : 'true'); });
  });

  /* ---------- Formulaire : ouvre le checkout Shopify prérempli ---------- */
  var cod = $('cod');
  function err(id, msg) {
    var i = $(id), e = i.parentNode.querySelector('.err');
    i.setAttribute('aria-invalid', msg ? 'true' : 'false');
    i.parentNode.classList.toggle('ok', !msg && i.value.trim().length > 0);
    e.textContent = msg || ''; e.hidden = !msg;
  }
  var norm = function (v) { return v.replace(/[\s.\-()]/g, '').replace(/^00212/, '0').replace(/^\+?212/, '0'); };
  var checks = {
    nom: function (v) { return v.trim().length < 2 ? tr('err_name') : ''; },
    tel: function (v) { return /^0[5-7]\d{8}$/.test(norm(v)) ? '' : tr('err_phone'); },
    ville: function (v) { return v.trim().length < 2 ? tr('err_city') : ''; },
    adr: function (v) { return v.trim().length < 4 ? tr('err_address') : ''; }
  };
  if (cod) {
    var hasFields = !!$('nom');
    if (hasFields) Object.keys(checks).forEach(function (id) { $(id).addEventListener('blur', function () { if (this.value) err(id, checks[id](this.value)); }); });
    cod.addEventListener('submit', function (e) {
      e.preventDefault();
      var first = null;
      if (hasFields) Object.keys(checks).forEach(function (id) { var m = checks[id]($(id).value); err(id, m); if (m && !first) first = $(id); });
      var ok = $('age').checked; $('ageErr').hidden = ok; if (!ok && !first) first = $('age');
      if (sum() !== offer().n) {
        var mxEl = $('mixer'); mxEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        mxEl.classList.remove('shake'); void mxEl.offsetWidth; mxEl.classList.add('shake'); return;
      }
      if (first) { first.focus(); return; }

      var items = used().map(function (k) { return F[k].id + ':' + s.mix[k]; });
      if (!hasFields) {
        var b0 = $('codBtn'); if (b0) { b0.disabled = true; b0.firstChild.nodeValue = tr('wait'); }
        var R0 = (G.routes || {});
        fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
          .then(function () { return fetch(R0.cartAdd || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: used().map(function (k) { return { id: F[k].id, quantity: s.mix[k] }; }) }) }); })
          .then(function (r) { if (!r.ok) throw r; location.href = cfg.codUrl || '/cart?cod=1'; })
          .catch(function () { if (b0) { b0.disabled = false; b0.firstChild.nodeValue = tr('order_now_total', { t: fm(total()) }); } alert(tr('add_error')); });
        return;
      }
      var full = $('nom').value.trim().replace(/\s+/g, ' ');
      var sp = full.indexOf(' ');
      var firstName = sp > 0 ? full.slice(0, sp) : full;
      var lastName = sp > 0 ? full.slice(sp + 1) : full;
      var tel = norm($('tel').value);
      var params = [
        ['checkout[shipping_address][first_name]', firstName],
        ['checkout[shipping_address][last_name]', lastName],
        ['checkout[shipping_address][address1]', $('adr').value.trim()],
        ['checkout[shipping_address][city]', $('ville').value.trim()],
        ['checkout[shipping_address][country]', cfg.country || 'Morocco'],
        ['checkout[shipping_address][phone]', '+212' + tel.slice(1)]
      ].map(function (p) { return encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1]); }).join('&');
      var btn = $('codBtn'); if (btn) { btn.disabled = true; btn.firstChild.nodeValue = tr('wait'); }
      location.href = '/cart/' + items.join(',') + '?' + params;
    });
  }
  /* Bouton secondaire : ajouter l'offre choisie au panier (panier latéral) */
  var addBtn = $('addCartBtn');
  if (addBtn) addBtn.addEventListener('click', function () {
    if (sum() !== offer().n) {
      var mxEl = $('mixer'); if (mxEl) { mxEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); mxEl.classList.remove('shake'); void mxEl.offsetWidth; mxEl.classList.add('shake'); }
      return;
    }
    var items = used().map(function (k) { return { id: F[k].id, quantity: s.mix[k] }; });
    var lbl = addBtn.querySelector('span'), txt = lbl.textContent;
    addBtn.disabled = true; lbl.textContent = tr('wait');
    fetch((G.routes || {}).cartAdd || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return window.FAYQCart ? window.FAYQCart.refresh(true) : (location.href = '/cart'); })
      .catch(function (err) { alert((err && err.description) || tr('add_error')); })
      .then(function () { addBtn.disabled = false; lbl.textContent = txt; });
  });
  var waAsk = $('waAsk');
  if (waAsk && cfg.whatsapp) waAsk.addEventListener('click', function () {
    waAsk.href = 'https://wa.me/' + cfg.whatsapp + '?text=' + encodeURIComponent(tr('wa_msg', { l: label(), t: fm(total()) }));
  });

  /* ---------- Défilement : barre collante, chapitres, apparitions ---------- */
  if (!reduce) document.documentElement.classList.add('js');
  var items = [];
  q('.pv3 section h2').forEach(function (el) { el.setAttribute('data-rv', ''); items.push(el); });
  q('.pv3 [data-rs] > *').forEach(function (el) { var i = Array.prototype.indexOf.call(el.parentNode.children, el); el.setAttribute('data-rv', ''); el.style.setProperty('--d', (i * 0.08) + 's'); items.push(el); });
  var navEl = $('pv3Chapters');
  if (navEl) {
    var host = navEl.closest('.shopify-section'), mainEl = document.querySelector('main');
    if (host && mainEl && host.parentNode === mainEl) mainEl.insertBefore(navEl, host.nextSibling);
  }
  var chapters = q('#chapters a').filter(function (a) {
    var ok = !!document.querySelector(a.getAttribute('href'));
    if (!ok) a.hidden = true;
    return ok;
  });
  var secs = chapters.map(function (a) { return document.querySelector(a.getAttribute('href')); });
  var bar = $('pv3Chapters'), header = document.querySelector('.section-header') || document.querySelector('header.site');
  var bb = $('buybar'), bbBtn = $('bbBtn');
  function fit() { if (bar && header) bar.style.top = (header.offsetHeight - 1) + 'px'; var sc = document.querySelector('.pv3 .stage-col'); if (sc && header) sc.style.top = (header.offsetHeight + 16) + 'px'; }
  function frame() {
    var y = scrollY, H = innerHeight;
    items = items.filter(function (el) { if (el.getBoundingClientRect().top < H * 0.92) { el.classList.add('in'); return false; } return true; });
    if (cod && bb) {
      var f = cod.getBoundingClientRect(), show = y > 400 && (f.bottom < 0 || f.top > H);
      bb.classList.toggle('show', show); bb.setAttribute('aria-hidden', show ? 'false' : 'true'); if (bbBtn) bbBtn.tabIndex = show ? 0 : -1;
    }
    var act = -1; secs.forEach(function (sct, i) { if (sct.getBoundingClientRect().top < 170) act = i; });
    chapters.forEach(function (a, i) { a.classList.toggle('on', i === act); });
    if (act >= 0) { var a = chapters[act], wrap = a.parentNode; if (a.offsetLeft < wrap.scrollLeft || a.offsetLeft + a.offsetWidth > wrap.scrollLeft + wrap.clientWidth) wrap.scrollLeft = a.offsetLeft - 20; }
  }
  // Calcul direct à chaque défilement (7 mesures, coût négligeable) : le chapitre actif ne prend jamais de retard.
  addEventListener('scroll', function () { frame(); }, { passive: true });
  addEventListener('resize', function () { fit(); frame(); });

  render(false); fit(); frame();
  if (fromPack) {
    var offersEl = $('offers');
    if (offersEl) setTimeout(function () { offersEl.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }, 300);
  }
})();
